// extracted by mini-css-extract-plugin
export default {"appLayout":"MainLayout_appLayout__zVQP2","mainContent":"MainLayout_mainContent__wMqHY"};